import DatabaseService from 'services/DatabaseService.js';
import {ADD_ALERT, POP_ALERT, CLEAR_ALERTS} from 'actions/types';

//Action Creators
export const addAlert = (alert) => {
    return { type:ADD_ALERT, alert:alert };
}
export const popAlert = () => {
    return { type:POP_ALERT };
}
export const clearAlerts = () => {
    return { type:CLEAR_ALERTS };
}






// WEBPACK FOOTER //
// ./src/actions/alertModals.js